module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/back-arrow-ac7882aae0979c980cd552f12d12bac1.svg";